import { JsonPatchOperation } from "common/services/api/attorney-hub-api-service";
import MarketplaceTeam from "marketplace/entities/marketplace-team/marketplace-team";


export default class UpdateMarketplaceTeamAPIRequest {
  payload: JsonPatchOperation[] = [];

  constructor(
    originalTeam: MarketplaceTeam,
    updatedTeam: MarketplaceTeam
  ) {
    if (updatedTeam.profile.name !== originalTeam?.profile.name)
      this.payload.push({
        op: "replace",
        path: "/name",
        value: updatedTeam.profile.name,
      });
    if (updatedTeam.profile.description !== originalTeam?.profile.description)
      this.payload.push({
        op: "replace",
        path: "/description",
        value: updatedTeam.profile.description,
      });
    const originalCategories = originalTeam?.profile.categories ?? [];
    const updatedCategories = updatedTeam.profile.categories ?? [];

    const areCategoriesDifferent =
      originalCategories.length !== updatedCategories.length ||
      originalCategories.some(cat => !updatedCategories.includes(cat)) ||
      updatedCategories.some(cat => !originalCategories.includes(cat));

    if (
      areCategoriesDifferent &&
      (originalCategories.length > 0 || updatedCategories.length > 0)
    ) {
      this.payload.push({
        op: "replace",
        path: "/categories",
        value: updatedCategories,
      });
    }
    if (updatedTeam.profile.avatarId?.value !== originalTeam?.profile.avatarId?.value)
      this.payload.push({
        op: "replace",
        path: "/avatarId",
        value: updatedTeam.profile.avatarId?.value,
      });
    if (updatedTeam.isVisible !== originalTeam?.isVisible)
      this.payload.push({
        op: "replace",
        path: "/isVisible",
        value: updatedTeam.isVisible,
      });
  }
}
